import {getYear} from 'date-fns';

const minYear = 1900;
const currentYear = getYear(Date.now());
const futureYears = 5;
const maxYear = currentYear + futureYears;

const options = Array(maxYear - minYear + 1)
  .fill(minYear)
  .map((year, index) => {
    const option = `${year + index}`;
    return {
      value: option,
      label: option,
    };
  });

export const yearOptionsWithFuture = options.sort(
  (a, b) => parseInt(b.value, 10) - parseInt(a.value, 10)
);
